export default "__VITE_ASSET__Bi00uE5F__"